import React, { useState } from "react";
import {
  AppBar,
  Box,
  Button,
  Grid,
  IconButton,
  InputBase,
  Paper,
  Toolbar,
  Typography,
  Menu,
  MenuItem,
} from "@mui/material";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { WSIcons } from "../../../commonFunctions/iIcons";
import UserRole from "./UserRole";
import { IMetaData } from "../../../Components/Dialog/WSCommonDialog";
import { openPopUp } from "../../../Components/Dialog/OpenNewModal";

export const UserRoleList: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  
  const handleData = async (data: any) => {
    debugger;
    console.log("onsubmit===>", data); // You can perform any action with the submitted data here
  };
  const metadata: IMetaData = {
    title: "User Role",
    hideActions: false,
    content: (props: any, row: any) => (
      <UserRole {...props}/>
    ),
    actions: [
      {
        label: "Cancel",
        className: "ws-cancel",
        type: "button",
      },
      {
        label: "submit",
        type: "submit",
        onClick: handleData,
        autoFocus: true,
      },
    ],
    isDragable: true,
  };
  const handleClick = () => {
    openPopUp(metadata, handleData);
  };
  const columns: IColumns[] = [
    {
      header: "Name",
      fieldName: "",
      tooltip: true,
    },
    {
      header: "Description",
      fieldName: "",
      tooltip: true,
    },
    {
      header: "Parent User Role",
      fieldName: "",
      tooltip: true,
    },
  ];

  return (
    <Grid
      container
      mt={10}
      direction="column"
      sx={{
        height: "100vh", // Make the container fill the full height
      }}
    >
      {/* Top AppBar */}
      <AppBar position="static" color="default" elevation={1}>
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            User Role List
          </Typography>
          <Typography variant="body2" sx={{ color: "gray", mr: 2 }}>
            1 Record(s)
          </Typography>
          <Paper
            component="form"
            sx={{
              display: "flex",
              alignItems: "center",
              width: 200,
              borderRadius: 1,
              p: "2px 4px",
              mr: 2,
            }}
          >
            <InputBase
              placeholder="Search"
              inputProps={{ "aria-label": "search users" }}
              sx={{ ml: 1, flex: 1 }}
            />
            <IconButton type="button" aria-label="search">
              <WSIcons.SearchIcon />
            </IconButton>
          </Paper>
          <IconButton onClick={handleMenuOpen}>
            <WSIcons.ViewListIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <MenuItem onClick={handleMenuClose}>Update UserPrevilage</MenuItem>
            <MenuItem onClick={handleMenuClose}>Import User Role </MenuItem>
            <MenuItem onClick={handleMenuClose}>Export User Role </MenuItem>
            <MenuItem onClick={handleMenuClose}>Language</MenuItem>

          </Menu>
        </Toolbar>
      </AppBar>

      {/* User Table */}
      <Box
        sx={{
          flex: 1, // Pushes the footer to the bottom
          overflow: "auto", // Enables scrolling if the table content is large
        }}
      >
        <WSDataGrid id="itemGrid" title="" columns={columns} />
      </Box>

      {/* Footer Buttons */}
      <Box
        sx={{
          bgcolor: "#f4f4f4",
          p: 1,
          borderTop: "1px solid #ddd", // Optional: Adds a border to the top of the footer
        }}
      >
        <Grid container justifyContent="flex-end" spacing={1}>
          <Grid item>
            <Button variant="outlined" sx={{ color: "black", borderColor: "black" }} onClick={handleClick}>
              New
            </Button>
          </Grid>
          <Grid item>
            <Button variant="outlined" sx={{ color: "black", borderColor: "black" }}>
              Edit
            </Button>
          </Grid>
          <Grid item>
            <Button variant="outlined" sx={{ color: "black", borderColor: "black" }}>
              Delete
            </Button>
          </Grid>
          <Grid item>
            <Button variant="outlined" sx={{ color: "black", borderColor: "black" }} onClick={onClose}>
              Close
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
};
